/* eslint-disable no-restricted-syntax */
/* eslint-disable no-labels */
import { Component } from 'preact';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../../../Global/Icon';
import Text from '../../../Global/Text';
import Coverage from '../Coverage';
import Label from '../../../Form/Label';
import { isCompactWidget } from '../../../../actions/App';

import { checkConditions } from '../../../../utilities/package/packageUtils';
import { actionHandler } from '../../../../utilities/form/formUtils';

class SelectorItem extends Component {
  render() {
    const {
      recommendedText,
      coverageCodes,
      initialValues,
      coverageCodesMerge,
      productSelector,
      packageItem,
      userData,
      isRecommended,
      actions,
      labelActions,
      values,
      dispatch,
      setValues,
      campaign,
      column,
      toolTip,
      unit,
      feesAndCharges,
      customProductFooterNote,
      selectedItem,
      customTotalPriceText,
    } = this.props;

    const { coverageList, packages } = initialValues;

    const {
      title,
      buttonText,
      packagePrice,
      packageId,
      variant,
      showPrePrice,
      packagePrePrice,
      showExcessAmount,
      packageExcessAmount,
      showTurnoverPrice,
      showAnnualPrice,
      overwritePrimaryButtonClass,
      customProduct,
      customProductProps,
    } = productSelector;

    const headerCampaign =
      campaign &&
      campaign.header &&
      checkConditions(campaign.header.conditions, userData)
        ? campaign.header
        : null;
    const addCampaign =
      campaign && campaign.advantages ? [...campaign.advantages] : [];

    const selectorClass = classNames(
      'grid__col grid__col--12',
      'product-selector__item product-selector__item--v3 ie-border',
      {
        [`grid__col--md-${column}`]: column,
        'product-selector--recommended-v2': isRecommended,
      }
    );

    const buttonClasses = classNames('button', {
      'button--secondary': !isRecommended && !overwritePrimaryButtonClass,
      'button--primary': isRecommended || overwritePrimaryButtonClass,
    });

    const screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    const priceClasses = classNames('price', {
      'price--align': !showPrePrice,
    });
    const advantageCoverages = coverageCodes
      .filter(
        (item) =>
          coverageList &&
        coverageList[item] &&
        coverageList[item].icon
      );

    let level0 = [];
    let level1 = [];
    let level2 = [];
    coverageCodes
      .filter(
        (item) => coverageList && coverageList[item] && !coverageList[item].icon
      )
      .forEach((code) => {
        coveragesLoop: for (const p of packages) {
          for (const c of p.coverages) {
            if (c.code === code && c.style === 'highlighted') {
              switch (p.packageName) {
                case 'Udvidet':
                  level1 = [...level1, code];
                  break;
                case 'Super':
                  level2 = [...level2, code];
                  break;
                default:
                  level0 = [...level0, code];
                  break;
              }
              // eslint-disable-next-line no-labels
              break coveragesLoop;
            }
          }
        }
      });
    const packageClass = classNames('package-main-box', {
      'package-mobile-selected-v3': title === selectedItem,
    });

    let coverageStyle = variant === 'modal' ? 'nameText' : 'listProps';

    coverageStyle = isCompactWidget() ? 'compactButton' : coverageStyle;

    return (
      <div className={packageClass}>
        {/* Super, Udvidet or Basis header */}
        <div className='box-heading'>
          {title && (
            <h3>
              <Text value={title} className='left' component='strong' />
            </h3>
          )}
        </div>
        {/* Package */}
        <div className={selectorClass} >
          {isRecommended && (
            <div className='product-recommended-v3'>
              <Text value={recommendedText} />
            </div>
          )}
          <div
            className={`product-selector__item__inner product-selector__item__inner-v2 v3 tealiumLink ${
              isRecommended ? 'package--recommended' : ''
            }`}
          >
            {/* Coverages */}

            <ul className='product-selector--coverage-outer-v2'>
              {coverageCodesMerge &&
                Object.keys(coverageCodesMerge).map((key) => (
                  <li className='product-selector--coverage-v2 product-selector--coverage-v3'>
                    <div className={coverageCodesMerge[key]} data-rh={toolTip}>
                      {(!variant || variant !== 'modal') && (
                        <Icon icon='checkmark' fill='black' />
                      )}
                      <div className='coverage'>
                        <Coverage
                          variant={coverageStyle}
                          coverageCode={key}
                          showDescription={false}
                        />
                      </div>
                    </div>
                  </li>
                ))}
              {[level2, level1, level0].map(
                (level, i) =>
                  level.length > 0 && (
                    <li
                      Key={`${level.toString()}-${i}`}
                      className="no-styles-list"
                    >
                      <ul className={`coverage-level coverage-level-${2 - i}`}>
                        {level.map((listItem) => (
                          <li className='product-selector--coverage-v2 product-selector--coverage-v3'>
                            <div
                              className={packageItem.coverages.reduce(
                                (ag, coverage) => {
                                  if (
                                    coverage.code === listItem &&
                                    checkConditions(
                                      coverage.conditions,
                                      userData
                                    ) &&
                                    variant !== 'modal'
                                  ) {
                                    return coverage.style;
                                  }
                                  return ag;
                                },
                                ''
                              )}
                              data-rh={toolTip}
                            >
                              {(!variant || variant !== 'modal') && (
                                <Icon {...{ icon: 'checkmark', fill: 'black' }} />
                              )}
                              <div className='coverage'>
                                <Coverage
                                  variant={coverageStyle}
                                  coverageCode={listItem}
                                  showDescription={false}
                                />
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </li>
                  )
              )}
            </ul>

            {/* Advantage */}

            {advantageCoverages.length > 0 && (
            <ul className='coverage-level product-selector--coverage-outer-add'>
              {advantageCoverages
                .map((listItem) => (
                  <li className='product-selector--coverage-add'>
                    <div data-rh={toolTip}>
                      <Icon
                        {...{
                          icon: coverageList[listItem].icon,
                          className: 'branded',
                        }}
                      />
                      <div className='advantage'>
                        <Coverage
                          variant={coverageStyle}
                          coverageCode={listItem}
                          showDescription={false}
                        />
                      </div>
                    </div>
                  </li>
                ))}
              {addCampaign
                .filter((item) => checkConditions(item.conditions, userData))
                .map((listItem) => (
                  <li className='product-selector--coverage-add'>
                    <div data-rh={toolTip}>
                      <Icon icon='add' />
                      <div className='advantage'>
                        <Label
                          id='advancedProductFooterNote'
                          label={listItem.text}
                          className='right'
                          actions={
                            variant !== 'modal' ? listItem.actions : null
                          }
                          dispatch={dispatch}
                          values={values}
                          setValues={setValues}
                        />
                      </div>
                    </div>
                  </li>
                ))}
            </ul>)}
            {/* Price and pre price */}

            <div
              className='product-selector--headline'
              id={`${packageId}-product-selector--headline`}
            >
              <div className='headline-wrapper-v3'>
                {showPrePrice && packagePrePrice && (
                  <div className='preprice'>
                    <Text value='Pris' component='span' />
                    <div className='preprice--right'>
                      <Text
                        value={packagePrePrice}
                        numberFormat={true}
                        component='span'
                      />
                      <Text
                        value={` ${unit}`}
                        numberFormat={false}
                        component='span'
                      />
                    </div>
                  </div>
                )}
                {showExcessAmount && packageExcessAmount && (
                  <div className='preprice'>
                    <Text value='Selvrisiko' component='span' />
                    <div>
                      <Text
                        value={packageExcessAmount}
                        numberFormat={true}
                        component='span'
                      />
                      <Text
                        value=' kr.'
                        numberFormat={false}
                        component='span'
                      />
                    </div>
                  </div>
                )}
                {showAnnualPrice && (
                  <div className='preprice preprice--margin'>
                    <Text value='Årlig pris' component='span' />
                    <div>
                      <Text
                        value='$[turnoverValueText]'
                        numberFormat={true}
                        component='span'
                      />
                      <Text
                        value=' kr./år.'
                        numberFormat={false}
                        component='span'
                      />
                    </div>
                  </div>
                )}
                {headerCampaign && (
                  <div className='online-discount'>
                    <Label
                      id='campaignHeader'
                      label='Din onlinerabat'
                      actions={headerCampaign.actions}
                      dispatch={dispatch}
                      values={values}
                      setValues={setValues}
                      toolTip={toolTip}
                    />
                    <div>
                      <Text
                        value={headerCampaign.text.replace(
                          'PACKAGEID',
                          packageId
                        )}
                        component='span'
                        numberFormat={true}
                      />
                      <Text
                        value={` ${unit}`}
                        numberFormat={false}
                        component='span'
                        className='box-small'
                      />
                    </div>
                  </div>
                )}
                {/* add footer notes to package if custom footer note */}
                {customProductFooterNote &&
                  <div className='fees-and-charges'>
                    {
                      (() => {
                        if (customProductProps[`is${customProduct}`]) {
                          return <Text
                            numberFormat={false}
                            component='p'
                            value={customProductFooterNote}
                            className='price-package-footer-note--custom'
                          />;
                        }
                        return (
                        <div className='charges'>
                          <Label
                            id='chargesModal'
                            label={feesAndCharges}
                            className='label__action'
                            actions={labelActions}
                            dispatch={dispatch}
                            values={values}
                            setValues={setValues}
                          />
                          <div>
                            <Text
                              value={`$[taxFee${title}]`}
                              component='span'
                              numberFormat={true}
                            />
                            <Text
                              value={` ${unit}`}
                              numberFormat={false}
                              component='span'
                              className='box-small'
                            />
                          </div>
                        </div>);
                      })()
                    }
                  </div>
                }
                <div className={priceClasses}>
                  {packagePrice && (
                    <div className='price-row'>
                      <Text value={customTotalPriceText} component='strong' />
                      <div>
                        <Text
                          value={packagePrice}
                          numberFormat={true}
                          component='span'
                          className='box-subheading'
                        />
                        <Text
                          value={unit}
                          numberFormat={false}
                          component='span'
                          className='box-small price-unit'
                        />
                      </div>
                    </div>
                  )}
                  {showTurnoverPrice && (
                    <div className='price-row'>
                      <Text value={customTotalPriceText} component='strong' />
                      <div>
                        <Text
                          value={userData.turnoverValueMonth}
                          numberFormat={true}
                          component='span'
                          className='box-subheading'
                        />
                        <Text
                          value={unit}
                          numberFormat={false}
                          component='span'
                          className='box-small'
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Button */}

            <div className='product-selector--footer-outer-v3'>
              <div className='product-button-wrapper'>
                {buttonText && actions && (
                  <button
                    type='button'
                    className={screenWidth > 768 ? buttonClasses : 'button button--primary'}
                    id={packageId}
                    name={packageId}
                    onClick={(e) =>
                      actionHandler(
                        actions,
                        null,
                        e,
                        dispatch,
                        {
                          ...values,
                          ...userData,
                          packageId,
                          chosenPackage: packageId,
                          chosenPackageName: title,
                          ...customProductProps,
                        },
                        setValues,
                        { chosenPackage: packageId, chosenPackageName: title }
                      )
                    }
                  >
                    <Text value={buttonText} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SelectorItem;

SelectorItem.defaultProps = {
  toolTip: null,
  selectedItem: '',
  feesAndCharges: '',
  labelActions: [],
  overwritePrimaryButtonClass: false,
  customProductFooterNote: '',
  customTotalPriceText: '',
};

SelectorItem.propTypes = {
  coverageCodesMerge: PropTypes.object,
  recommendedText: PropTypes.string.isRequired,
  productSelector: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  coverageCodes: PropTypes.array.isRequired,
  isRecommended: PropTypes.bool.isRequired,
  coverageText: PropTypes.string.isRequired,
  packageItem: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  actions: PropTypes.array.isRequired,
  setValues: PropTypes.func,
  campaign: PropTypes.object.isRequired,
  column: PropTypes.number.isRequired,
  unit: PropTypes.string,
  toolTip: PropTypes.string,
  selectedItem: PropTypes.string,
  customProductFooterNote: PropTypes.string,
  feesAndCharges: PropTypes.string,
  labelActions: PropTypes.array,
  overwritePrimaryButtonClass: PropTypes.bool,
  customTotalPriceText: PropTypes.string,
};
